import { proxy } from 'valtio';

// 定义更严格的类型
export interface SSEState<T = any> {
    data: T | null;
    trace: T | null;
    loading: boolean;
    error: Error | null;
    params: Record<string, string>;
    requestId: string; // 非空时触发请求，消费后清空
}

export const sseStore = proxy<SSEState>({
    data: "",
    trace: "",
    loading: false,
    error: null,
    params: {},
    requestId: "",
});
